<template>
	<article v-if="saved">
		<template v-if="stage === 'addForeign'" class='question'>
			<textarea v-model.trim="lang2" placeholder="Foreign Language" autofocus></textarea>
			<button @click="stage = 'addNative'" class='addNative'>Next</button>
		</template>
		<template v-else-if="stage === 'addNative'" class='answer'>
			<textarea v-model.trim="lang1" placeholder='Native Language' autofocus></textarea>
			<button @click="save" class='save'>Add</button>
		</template>
	</article>

	<article v-else>
		saving...
	</article>
</template>

<script>
export default {
	name: 'AddVocab',
	data() {
		return {
			lang1: null,
			lang2: null,
			saved: true,
			stage: 'addForeign'
		};
	},
	methods: {
		save() {
			if (this.lang1 && this.lang1 !== '' && this.lang2 && this.lang2 !== '') {
				this.saved = false;
				fetch('https://vocabtrainer-4ddc9.firebaseio.com/vocabs.json',
					{
						method: 'POST',
						body: JSON.stringify({
							lang1: this.lang1, lang2: this.lang2, updatedAt: Math.round(Date.now() / 1000)
						})
					})
					.then((res) => {
						if (res.ok) {
							return res.blob;
						}
						throw new Error('Network response was not ok.');
					})
					.then((myBlob) => {
						this.lang1 = null;
						this.lang2 = null;
						this.saved = true;
						this.stage = 'addForeign';
					})
					.catch((error) => console.log(`There has been a problem with your fetch operation: ${error.message}`));
			}
		}
	}
};
</script>

<style scoped>
article {
	grid-area: main;
	justify-self: center;
	align-self: center;
	height: 60vh;
	display: inline-grid;
	grid-template-columns: 1fr;
	/*grid-template-rows: 1fr 1fr;*/
	grid-template-rows: 75% 25%;
	max-height: 50vh;
	font-size: var(--fontx30);
	background-color: white;
	color: var(--blue1);
	justify-content: stretch;
	/*for first line alignment*/
	align-items: center;
	/*for multi-row alignment*/
	text-align: center;
	border-radius: 0.5em;
	cursor: pointer;
}

@media only screen and (max-width: 800px) {
	article {
		width: 80%;
		padding: 0;
	}
	/*
	button.add {
		border-radius: 0.5em;
		height: 100%;
	}
	*/
}

@media only screen and (min-width: 800px) {
	article {
		width: calc(50vh * 2);
	}

	button.add {
		border-radius: 50%;
		height: calc(100% - 2em);
		margin-right: 1em;
		margin-left: 1em;
	}
}

textarea {
	color: var(--blue1);
	font-size: var(--fontx25);
	border-top-left-radius: 0.5em;
	border-top-right-radius: 0.5em;
	border-style: none;
	margin-top: 0.5em;
	margin-left: 0.25em;
	margin-right: 0.25em;
	/*
	grid-row-start: 1;
	grid-row-end: 2;
	*/
	height: 100%;
}

button {
	/*margin: 0.7em 0.5em 0.7em 0.5em;*/
	/*margin: 2em 1em 2em 1em;*/
	border-top: 4px var(--blue1) solid;
	background-color: white;
	color: var(--blue1);
	border-bottom-left-radius: 0.7em;
	border-bottom-right-radius: 0.7em;
	border-bottom: none;
	border-left: none;
	border-right: none;
	font-size: var(--fontx20);
	/*border-width: 0;*/
	cursor: pointer;
	/*
	grid-row-start: 2;
	grid-row-end: 3;
	*/
	/*padding: 1em;*/
	height: 100%;
}
</style>


// WEBPACK FOOTER //
// AddVocab.vue?6dd5bd12